export const PAGE_TYPES = {
  COLLECTION: 'collection',
  SUBCOLLECTION: 'subcollection',
  PARTNER_PDP: 'partnerProduct',
  FAQ: 'faqPage',
  PRODUCT_AND_BUNDLE: 'product',
  LANDING: 'page',
  AUTH: 'authenticationPage',
  ACCOUNT: 'accountPage',
  HOME: 'homePage',
  SITE: 'site',
  SEARCH: 'search',
} as const

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES]
type TRoutePatterns = keyof typeof PAGE_TYPES | 'PRODUCT' | 'BUNDLE'

export const PAGE_TYPE_TO_PATH_PREFIX: Partial<Record<TRoutePatterns, string>> = {
  COLLECTION: 'shop',
  PRODUCT: 'p',
  BUNDLE: 'p/bn',
  PARTNER_PDP: 'partner',
}
